import React, { useState, useEffect } from 'react';
import './gallery2.css';

const ImageGallery = ({ images }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [showArrows, setShowArrows] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedImageIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
    }, 3000); // Set autoplay interval to 3 seconds

    return () => {
      clearInterval(interval);
    };
  }, [images]);

  const handlePrevClick = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };

  const handleNextClick = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  return (
    <div className="image-galleryy"
      onMouseEnter={() => setShowArrows(true)}
      onMouseLeave={() => setShowArrows(false)}>
      <div className="main-image">
        <img
          src={images[selectedImageIndex]}
          alt="Main"
          onMouseEnter={() => setShowArrows(true)}
        />
        {showArrows && (
          <div className="nav-arrows">
            <button className="prev-btn" onClick={handlePrevClick}>←</button>
            <button className="next-btn" onClick={handleNextClick}>→</button>
          </div>
        )}
      </div>
      <div className="thumbnail-images">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Thumbnail ${index + 1}`}
            onClick={() => setSelectedImageIndex(index)}
            className={selectedImageIndex === index ? 'selected' : ''}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageGallery;
